import React from 'react';
import { ToastContainer } from 'react-toastify';

const AdminLoginForm = ({
    username,
    password,
    showPassword,
    setUsername,
    setPassword,
    handleLogin,
    togglePasswordVisibility,
    nmaispeloImage,
}) => {
    const AdminFormStyles = {
        body: {
            background: '#f3f3f3',
            fontFamily: 'Montserrat , sans-serif',
        },

        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#f4f7fc',
            padding: '20px',
        },
        formContainer: {
            backgroundColor: '#ffffff',
            padding: '40px',
            borderRadius: '10px',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
            maxWidth: '400px',
            width: '100%',
            textAlign: 'center',
        },
        title: {
            marginBottom: '30px',
            fontSize: '24px',
            fontWeight: '600',
            color: '#333333',
        },
        input: {
            width: '100%',
            padding: '12px',
            marginBottom: '20px',
            borderRadius: '5px',
            border: '1px solid #dddddd',
            fontSize: '16px',
            boxSizing: 'border-box',
        },
        button: {
            width: '100%',
            padding: '12px',
            borderRadius: '5px',
            backgroundColor: '#8EBE21',
            color: '#ffffff',
            fontSize: '16px',
            border: 'none',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
        },
        buttonHover: {
            backgroundColor: '#349237',
        },
        showPasswordButton: {
            position: 'absolute',
            right: '10px',
            top: '0',
            bottom: '0',
            margin: 'auto',
            height: '20px',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: '#1d1d1d',
            fontSize: '14px',
            padding: '0',
        },
    };

    return (
        <div style={AdminFormStyles.container}>
            <ToastContainer />

            <div style={AdminFormStyles.formContainer}>
                <img
                    src={nmaispeloImage}
                    alt="Imagem antes dos filtros"
                    style={{
                        display: 'block',
                        width: '50%',
                        margin: '2rem auto 0 auto',
                        transition: 'width 0.5s ease-in-out',
                    }}
                />

                <h2 style={AdminFormStyles.title}>Admin Login</h2>

                <form onSubmit={handleLogin}>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Digite o usuário"
                        style={AdminFormStyles.input}
                    />

                    <div style={{ position: 'relative' }}>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Digite a senha"
                            style={AdminFormStyles.input}
                        />

                        <button
                            type="button"
                            onClick={togglePasswordVisibility}
                            style={AdminFormStyles.showPasswordButton}
                        >
                            {showPassword ? 'Ocultar' : 'Mostrar'}
                        </button>
                    </div>

                    <button type="submit" style={AdminFormStyles.button}>
                        Entrar
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLoginForm;